import { Stack, Text, Button } from '@mantine/core';
import { Plus } from 'react-feather';

interface GroupNoTimeSlotEmptyStateProps {
  onAddTimeSlot: () => void;
}

/**
 * MED-777: Actionable zero state shown when a group has no time slot assigned.
 * Replaces the passive "No sessions scheduled for this group" text in both
 * the P&G Groups view (GroupCard) and the Sessions tab (SessionGroupCard).
 */
export function GroupNoTimeSlotEmptyState({ onAddTimeSlot }: GroupNoTimeSlotEmptyStateProps) {
  return (
    <Stack align="center" gap="sm" py="md" px="xl">
      <Text size="sm" c="dimmed" ta="center" maw={420}>
        Sessions are generated once groups are created and have a time slot set.
        Add a time slot for this group to generate sessions.
      </Text>
      <Button
        leftSection={<Plus size={14} />}
        onClick={(e) => {
          e.stopPropagation();
          onAddTimeSlot();
        }}
      >
        Add Time Slot
      </Button>
    </Stack>
  );
}
